import { render, staticRenderFns } from "./CanadianPostalCode.vue?vue&type=template&id=041149d6&"
import script from "./CanadianPostalCode.vue?vue&type=script&lang=js&"
export * from "./CanadianPostalCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports